module.exports = __webpack_public_path__ + "assets/img/12-2.7d446f73.png";